export default __webpack_public_path__ + "static/media/100_39040.49f7c2f2.jpg";